import MyTabs from '../../components/MyTabs';
import Basic from './Basic';

const General = () => {

    const tabs = [
        { id: "basic", title: "Basic", Component: Basic },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default General;